import { render, staticRenderFns } from "./PaginationNavSize.vue?vue&type=template&id=77cebc2c"
import script from "./PaginationNavSize.vue?vue&type=script&lang=js"
export * from "./PaginationNavSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports